"use client";

import Image from "next/image";
import { Box, Stack, Typography } from "@mui/material";
import theme, { blueGradientSxDown } from "@/theme/theme";
import WeSpecializeCard from "@/components/home/weSpecializeInCard";
import WeSpecializeFrame from "@/components/home/weSpcializeInFrame";

import eu from "@/assets/images/eu.webp"
import eth from "@/assets/images/ethereum-eth-logo.webp"
import sol from "@/assets/images/solana-sol-logo.webp"
import base from "@/assets/images/base.webp"
import arb from "@/assets/images/arbitrum-arb-logo.webp"
import opt from "@/assets/images/optimism.webp"
import chainlink from "@/assets/images/chainlink-link-logo.webp"
import file from "@/assets/images/filecoin.webp"
import btc from "@/assets/images/btc.webp"

import nextjs from "@/assets/images/nextjs.webp"
import react from "@/assets/images/react.webp"
import vue from "@/assets/images/vue.webp"
import nodejs from "@/assets/images/nodejs.webp"
import go from "@/assets/images/go.webp"
import ts from "@/assets/images/ts.webp"
import rust from "@/assets/images/rust.webp"
import figma from "@/assets/images/figma.webp"

import gpt from "@/assets/images/gpt.webp"
import gemini from "@/assets/images/gemini.webp"
import mistral from "@/assets/images/mistral.webp"
import anthropic from "@/assets/images/anthropic.webp"
import grok from "@/assets/images/grok.webp"
import perp from "@/assets/images/perplexity.webp"
import copilot from "@/assets/images/mscopilot.webp"
import hf from "@/assets/images/hf.webp"

import mvpValidation from "@/assets/images/mvpValidation.webp"

import PM from "@/assets/images/privacyModels.webp"
import PQ from "@/assets/images/postQuantum.webp"

export default function WeSpecializeIn() {

    const cardStyle = {
        cursor: "pointer",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
            transform: "translateY(-5px)",
            filter: "brightness(1.2)",
            boxShadow: `0 10px 20px -5px ${theme.palette.brand.mgsBlue1.main}40`,
        }
    };

    return (
        <WeSpecializeFrame height={"fit-content"}>
            <Box
                sx={{
                    width: "fit-content",
                    px: 2,
                    position: "absolute",
                    top: { xs: "5%", lg: "10%" },
                    left: 0,
                    right: 0,
                    m: "0 auto",
                    zIndex: 5,
                }}
            >
                <Typography variant="h3" fontWeight={400}>
                    We specialize in
                </Typography>
            </Box>

            <Stack pt={7} px={1} width={"100%"}>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "repeat(1, minmax(0, 1fr))", lg: "repeat(5, minmax(0, 1fr))" },
                        gap: 2,
                        width: "100%",
                        height: "100%",
                        px: 2,
                        position: "relative",
                        zIndex: 10,
                        mt: 7,
                        alignItems: "stretch",
                        flex: "1 1 100%",
                        minWidth: 0,
                    }}
                >
                    <WeSpecializeCard radius={8} heightPx={200} sx={cardStyle}>
                        <Stack width={"100%"} flexGrow={1} alignItems="center" justifyContent="center" gap={2} padding={2}>
                            <Typography variant="h5" textAlign="center" fontWeight={500}>
                                GTM<br />
                                <Box
                                    component="span"
                                    sx={{
                                        ...blueGradientSxDown(theme),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    and Legal
                                </Box>
                            </Typography>
                            <Image src={eu} width={80} height={80} alt="eu"></Image>
                        </Stack>
                    </WeSpecializeCard>
                    <WeSpecializeCard radius={8} heightPx={200} sx={cardStyle}>
                        <Stack width={"100%"} flexGrow={1} alignItems="center" justifyContent="center" gap={2} paddingY={2.5}>
                            <Typography variant="h5" textAlign="center" fontWeight={500}>
                                <Box
                                component="span"
                                sx={{
                                        ...blueGradientSxDown(theme),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Blockchain & ERC
                                </Box>
                                <br />Integration
                            </Typography>
                            <Stack width={"100%"} gap={1}>
                                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap={1} paddingX={2}>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={eth} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={sol} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={base} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={arb} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                </Stack>
                                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap={1} paddingX={2}>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={opt} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={chainlink} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={file} width={17} height={17} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",

                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={btc} width={20} height={20} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Stack>
                    </WeSpecializeCard>
                    <WeSpecializeCard radius={8} heightPx={200} sx={cardStyle}>
                        <Stack width={"100%"} flexGrow={1} alignItems="center" justifyContent="center" gap={2} paddingY={2.5}>
                            <Typography variant="h5" textAlign="center" fontWeight={500}>
                                <Box
                                    component="span"
                                    sx={{
                                        ...blueGradientSxDown(theme),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    From Design
                                </Box>
                                <br />To Production
                            </Typography>
                            <Stack width={"100%"} gap={1}>
                                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap={1} paddingX={2}>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={nextjs} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1.2
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={react} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={vue} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={nodejs} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1.2
                                        }}></Image>
                                    </Stack>
                                </Stack>
                                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap={1} paddingX={2}>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={go} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1.2
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={ts} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={rust} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1.1
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={figma} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 0.7
                                        }}></Image>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Stack>
                    </WeSpecializeCard>
                    <WeSpecializeCard radius={8} heightPx={200} sx={cardStyle}>
                        <Stack width={"100%"} flexGrow={1} alignItems="center" justifyContent="center" gap={2} paddingY={2.5}>
                            <Typography variant="h5" textAlign="center" fontWeight={500}>
                                <Box
                                    component="span"
                                    sx={{
                                        ...blueGradientSxDown(theme),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    AI
                                </Box>
                                <br />Integration
                            </Typography>
                            <Stack width={"100%"} gap={1}>
                                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap={1} paddingX={2}>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={gpt} width={60} height={60} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1.2
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={gemini} width={35} height={35} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={mistral} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={anthropic} width={60} height={60} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1.2
                                        }}></Image>
                                    </Stack>
                                </Stack>
                                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap={1} paddingX={2}>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={grok} width={35} height={35} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",
                                            scale: 1.2
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={perp} width={20} height={20} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)"
                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={copilot} width={25} height={25} alt="eth" style={{
                                            filter: "brightness(0) invert(0.8)",

                                        }}></Image>
                                    </Stack>
                                    <Stack alignItems={"center"} justifyContent={"center"} padding={1} sx={{
                                        background: "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                                        boxShadow: "0px 2.38596px 7.15789px rgba(0, 0, 0, 0.25)",
                                        backdropFilter: "blur(1.43158px)",
                                        borderRadius: 1.25,
                                        border: `solid 0.5px rgba(149,149,149,0.40)`,
                                        width: 42,
                                        height: 41
                                    }}>
                                        <Image src={hf} width={16} height={16} alt="eth" style={{
                                            scale: 1.4
                                        }}></Image>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Stack>
                    </WeSpecializeCard>
                    <WeSpecializeCard radius={8} heightPx={200} sx={cardStyle}>
                        <Stack width={"100%"} flexGrow={1} alignItems="center" justifyContent="space-between" gap={2} paddingTop={2.5} position={"relative"} sx={{
                            overflow: "hidden"
                        }}>
                            <Typography variant="h5" textAlign="center" fontWeight={500}>
                                <Box
                                    component="span"
                                    sx={{
                                        ...blueGradientSxDown(theme),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    MVP
                                </Box>
                                <br />Validation
                            </Typography>
                            <Stack width={"100%"} gap={1}>
                                <Image alt="mvp validation" src={mvpValidation} width={100} height={80} style={{
                                    width: "100%",
                                }}></Image>
                            </Stack>
                        </Stack>
                    </WeSpecializeCard>
                </Box>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "repeat(1, minmax(0, 1fr))", lg: "repeat(2, minmax(0, 1fr))" },
                        gap: 2,
                        width: "100%",
                        height: "100%",
                        px: 2,
                        position: "relative",
                        zIndex: 10,
                        mt: 2,
                        mb: 5.5,
                        alignItems: "stretch",
                        flex: "1 1 100%",
                        minWidth: 0,
                    }}
                >
                    <WeSpecializeCard radius={8} heightPx={200} sx={cardStyle}>
                        <Stack width={"100%"} flexGrow={1} alignItems="center" justifyContent="center" gap={3} padding={2}>
                            <Typography variant="h5" textAlign="center" fontWeight={500}>
                                <Box
                                    component="span"
                                    sx={{
                                        ...blueGradientSxDown(theme),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Privacy Models&nbsp;
                                </Box> 
                                based on Zero Knowledge Proof
                            </Typography>
                            <Image src={PM} width={400} height={120} alt="Privacy models"></Image>
                        </Stack>
                    </WeSpecializeCard>
                    <WeSpecializeCard radius={8} heightPx={200} sx={cardStyle}>
                        <Stack width={"100%"} direction={"row"} flexGrow={1} alignItems="center" justifyContent="space-between" gap={2} py={2} px={6}>
                            <Typography variant="h5" fontWeight={500} style={{width: "30%"}}>
                                <Box
                                    component="span"
                                    sx={{
                                        ...blueGradientSxDown(theme),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Post Quantum
                                </Box>
                                Cryptography Models
                            </Typography>
                            <Image src={PQ} width={350} height={200} alt="Post quantum"></Image>
                        </Stack>
                    </WeSpecializeCard>
                </Box>
            </Stack>
        </WeSpecializeFrame>
    );
}
